import { OrderType } from 'graphql-api/gql-api-interfaces';

import { UiState } from '../../../models';

export function preSelectAnyDeliveryPeriodUi(state: UiState): UiState {
  return {
    ...state,
    preSelectedOrderType: OrderType.None,
  };
}
